"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverflowTooltip = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_bootstrap_1 = require("react-bootstrap");
var api_1 = require("../../../api");
var OverflowTooltip = function (_a) {
    var text = _a.text, children = _a.children;
    var textElementRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(false), hoverStatus = _b[0], setHover = _b[1];
    var compareSize = function () {
        var compare = textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
        setHover(compare);
    };
    (0, react_1.useEffect)(function () {
        compareSize();
    });
    (0, api_1.useMount)(function () {
        window.addEventListener('resize', compareSize);
        return function () {
            window.removeEventListener('resize', compareSize);
        };
    });
    return hoverStatus ? ((0, jsx_runtime_1.jsx)(react_bootstrap_1.OverlayTrigger, { placement: "top", overlay: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Tooltip, { id: "assessment-title-tooltip", role: "tooltip", children: text }), children: (0, jsx_runtime_1.jsx)("div", { className: "text-truncate", ref: textElementRef, children: children }) })) : ((0, jsx_runtime_1.jsx)("div", { className: "text-truncate", ref: textElementRef, children: children }));
};
exports.OverflowTooltip = OverflowTooltip;
exports.default = exports.OverflowTooltip;
